import { render, staticRenderFns } from "./LinkCopyLinkModal.vue?vue&type=template&id=3b6d34d2&"
import script from "./LinkCopyLinkModal.vue?vue&type=script&lang=js&"
export * from "./LinkCopyLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports